/**
 * Bug Report API service.
 * Provides operations for submitting bug reports.
 *
 * API Endpoints:
 * - POST /bug-reports - Create a new bug report (creates a GitHub issue)
 *
 * @module services/bugReportService
 */

import { httpClient } from './httpClient';
import type { BugReportRequest, BugReportResponse } from '@/types';

const ENDPOINT = '/bug-reports';

/**
 * Bug Report Service
 * Encapsulates all bug report API operations
 */
export const bugReportService = {
  /**
   * Submit a bug report.
   * This creates a GitHub issue in the ADC repository.
   * @param request - The bug report details
   * @returns Promise<BugReportResponse> - The created issue details
   */
  async submit(request: BugReportRequest): Promise<BugReportResponse> {
    console.log('[BugReportService] Submitting bug report:', request.title);
    try {
      const response = await httpClient.post<BugReportResponse>(ENDPOINT, request);
      console.log('[BugReportService] Bug report submitted, issue #', response.data.issueNumber);
      return response.data;
    } catch (error) {
      console.error('[BugReportService] Failed to submit bug report:', error);
      throw error;
    }
  },
};
